import { motion } from "framer-motion";
import PoliticalPartyCard from "./PoliticalPartyCard";

const politicalParties = [
  {
    name: "Bharatiya Janata Party",
    logo: "/party-logos/bjp.png",
    slogan: "Sabka Saath, Sabka Vikas",
    candidatesCount: 120,
    slug: "bjp",
  },
  {
    name: "Indian National Congress",
    logo: "/party-logos/congress.png",
    slogan: "Inclusive Growth, Social Justice",
    candidatesCount: 95,
    slug: "inc",
  },
  {
    name: "Aam Aadmi Party",
    logo: "/party-logos/aap.png",
    slogan: "Clean Politics. Honest Governance.",
    candidatesCount: 45,
    slug: "aap",
  },
  {
    name: "Independent Candidates",
    logo: "/party-logos/independent.png",
    slogan: "People First. Politics Later.",
    candidatesCount: 30,
    slug: "independent",
  },
];

const PoliticalPartiesSection = () => {
  const topCount = Math.max(...politicalParties.map((p) => p.candidatesCount));

  return (
    <section className="relative py-20 px-4 bg-white overflow-hidden">
      {/* 🔗 Background Image */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://akm-img-a-in.tosshub.com/indiatoday/images/story/202404/woman-voters-in-tripura-264344452-16x9_0.jpg?size=690:388')",
          }}
        />
        <div className="absolute inset-0 bg-orange-50/60 backdrop-blur-sm" />
      </div>

      {/* Section Header */}
      <div className="relative z-10 max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-4xl font-extrabold text-orange-700 mb-4 drop-shadow-sm">
          जानिए आपके क्षेत्र में कौन-कौन से राजनीतिक दल हैं
        </h2>
        <p className="text-gray-700 max-w-2xl mx-auto text-lg">
          राजनीतिक दलों की नीतियाँ, उम्मीदवार और वादे समझें। तुलना करें, सवाल पूछें और वोट सोच-समझकर दें।
        </p>
      </div>

      {/* Cards */}
      <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
        {politicalParties.map((party, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <PoliticalPartyCard
              {...party}
              isTop={party.candidatesCount === topCount}
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default PoliticalPartiesSection;
